import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
    Backdrop
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Navbar from '../navcomun';
import { useNavigate } from 'react-router-dom';
import servicio1 from '../../../services/servicio1';
import ConvocarJugadores from './convocar';
import fondoCancha from '../../../Assets/fondo-cancha.jpg'; // Asegurate que la ruta esté bien
import pelota from '../../../Assets/pelota.gif'; // Pelota girando
const niveles = ['Principiante', 'Amateur', 'Competitivo', 'Jugadores de liga'];
const tiposBusqueda = ['Jugador/Jugadores', 'Rival (equipo completo)'];
const tiposFutbol = ['Futbol 5', 'Futbol 6', 'Futbol 7', 'Futbol 8', 'Futbol 9', 'Futbol 10', 'Futbol 11'];
const tiposGenero = ['Masculino', 'Femenino', 'Mixto'];

export default function ListaPartidos() {
  const navigate = useNavigate();
  const [modalAbierto, setModalAbierto] = useState(false);
  const [partidoSeleccionado, setPartidoSeleccionado] = useState(null);
  const [nivel, setNivel] = useState('');
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [partidos, setPartidos] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState('');
  const [mostrandoPelota, setMostrandoPelota] = useState(false);
    const [genero, setGenero] = useState('');

  useEffect(() => {
    fetchPartidos();
  }, []);

  const fetchPartidos = async () => {
       setMostrandoPelota(true)
    try {
      const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser');
      let userData = null;
      if (loggedUserJSON) {
        userData = JSON.parse(loggedUserJSON);
        setUser(userData);
      }
      const data = await servicio1.traerpartidos({ id_usuario: userData?.id });
      setPartidos(data);
    } catch (error) {
      console.error('Error al traer los partidos', error);
    }
    setMostrandoPelota(false)
  };

  const abrirModal = (partido) => {
    setPartidoSeleccionado(partido);
    setModalAbierto(true);
  };

  const enviarAviso = async () => {
    try {
      await servicio1.sumarsepartido({
        id_partido: partidoSeleccionado.id,
        id_usuario: user.id,
      });
      setModalAbierto(false);
      alert('Aviso enviado al organizador');
      fetchPartidos();
    } catch (error) {
      console.error('Error al enviar aviso', error);
      alert('Ocurrió un error al intentar unirte al partido.');
    }
  };

  return (
<Box
  sx={{
    minHeight: '100vh',
    backgroundImage: `url(${fondoCancha})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    pb: 5,
  }}
>

      <Navbar />
      <Box
        sx={{
          maxWidth: 1000,
          mx: 'auto',
          mt: 3,
          p: 3,
          backgroundColor: 'rgba(255,255,255,0.93)',
          borderRadius: 3,
          boxShadow: 4,
        }}
      >
        {/* Filtros y búsqueda */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <SearchIcon sx={{ mr: 1 }} />
          <TextField fullWidth placeholder="Buscar partidos cerca tuyo" variant="outlined" size="small" />
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 2, mb: 3 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Nivel</InputLabel>
            <Select value={nivel} onChange={(e) => setNivel(e.target.value)} label="Nivel">
              {niveles.map((nivel) => (
                <MenuItem key={nivel} value={nivel}>{nivel}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Se busca</InputLabel>
            <Select value={tipoBusqueda} onChange={(e) => setTipoBusqueda(e.target.value)} label="Se busca">
              {tiposBusqueda.map((tipo) => (
                <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {partidos.map((partido) => {
          const esCreador = user && user.id === partido.id_creador;

          let fondoColor = '#e8f5e9';
          let bordeColor = '#2e7d32';

          if (partido.cupo === 0) {
            fondoColor = '#ffebee';
            bordeColor = '#d32f2f';
          } else if (esCreador) {
            fondoColor = '#d0f0fd';
            bordeColor = '#1976D2';
          }

          return (
            <Box
              key={partido.id}
              sx={{
                border: '2px solid',
                borderColor: bordeColor,
                backgroundColor: fondoColor,
                borderRadius: 2,
                p: 2,
                mb: 2,
              }}
            >
              {modalAbierto && (
                <Box
                  sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: 2,
                      p: 4,
                      maxWidth: 400,
                      width: '90%',
                      textAlign: 'center',
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      ¿Querés enviar aviso al organizador?
                    </Typography>
                    <Typography variant="body2" mb={2}>
                      El organizador recibirá tu intención de sumarte al partido en "{partidoSeleccionado?.nombrecancha}".
                    </Typography>
                    <Button variant="contained" color="primary" onClick={enviarAviso} sx={{ mr: 1 }}>
                      Enviar aviso
                    </Button>
                    <Button variant="outlined" onClick={() => setModalAbierto(false)}>
                      Cancelar
                    </Button>
                  </Box>
                </Box>
              )}

              {esCreador && <Typography color="info.main">📌 Creado por mí</Typography>}

              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                🏟️ Cancha "{partido.nombrecancha}" - Bº {partido.barrio}
              </Typography>
              <Typography variant="body2">
                🕘 {partido.hora} | {partido.cupo === 0 ? '✅ COMPLETO' : `⚽ Faltan ${partido.cupo} jugadores`}
              </Typography>
              <Typography variant="body2">
                Creado por: {partido.usuario}<br />
                🎯 Nivel: <b>{partido.nivel}</b>
              </Typography>

              {esCreador && <ConvocarJugadores id_partido={partido.id} />}

              {!esCreador && (
                <>
                  {partido.estado_sumada ? (
                    <Typography variant="body2" color="primary">
                      Ya estás anotado ({partido.estado_sumada})
                    </Typography>
                  ) : (
                    <Button
                      variant="contained"
                      color={partido.cupo === 0 ? 'secondary' : 'primary'}
                      sx={{ mt: 1 }}
                      onClick={() => abrirModal(partido)}
                    >
                      {partido.cupo === 0 ? 'Ver detalles' : '¡Me meto!'}
                    </Button>
                  )}
                </>
              )}
            </Box>
          );
        })}

        <Box textAlign="center" mt={4}>
          <Button
            variant="outlined"
            startIcon={<span>➕</span>}
            onClick={() => navigate('/falta1/crearpartidos')}
            sx={{
              backgroundColor: '#ffffffcc',
              borderRadius: 2,
              boxShadow: 2,
              px: 3,
              py: 1.5,
              fontWeight: 'bold'
            }}
          >
            Crear nuevo partido
          </Button>
        </Box>
      </Box>
       <Backdrop open={mostrandoPelota} sx={{ zIndex: 9999, color: '#fff', flexDirection: 'column' }}>
              <img src={pelota} alt="Registrando..." style={{ width: 80, height: 80, marginBottom: 10 }} />
              <Typography variant="h6" color="white">Procesando registro...</Typography>
            </Backdrop>
    </Box>
  );
}
